var module = angular.module('octopusApp.tasks');

module.controller("TaskStateEditDialogController", function($scope, $injector, task, $uibModalInstance, busy, octopusRepository, taskState) {
  var isLoading = $scope.isLoading = busy.create();
  var isPreviewing = $scope.isPreviewing = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  $scope.task = task;
  $scope.states = taskState.statesThatCanBeModified;
  $scope.state = task.State;
  $scope.reason = "";

  $scope.form = {
    state: task.State,
    reason: ""
  }

  $scope.accept = function() {
    isSaving.promise(octopusRepository.Tasks.changeState($scope.task, $scope.form.state, $scope.form.reason).then(function (p) {
      $uibModalInstance.close(true);
    }));
  };

  $scope.close = function() {
    $uibModalInstance.close();
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/controllers/task_state_edit_dialog_controller.js
// module id = 5274780242358340
// module chunks = 1